import axios from 'axios';
import { config } from '../app.config';

const { baseApiUrl } = config;

const RESTRICTED_API_ENDPOINT = `${baseApiUrl}/Api/OnlinePrijavaSteta/v1.0`;
const PUBLIC_API_ENDPOINT = `${baseApiUrl}/Api/OnlinePrijavaSteta/v1.0`;
// const RESTRICTED_API_ENDPOINT = `https://localhost:44357/v1.0`;
// const PUBLIC_API_ENDPOINT = `https://localhost:44357/v1.0`;

export const RestrictedAPI = axios.create({ baseURL: RESTRICTED_API_ENDPOINT, withCredentials: true }); // added sending credentials stored in Cookie to cross-domain
export const PublicAPI = axios.create({ baseURL: PUBLIC_API_ENDPOINT, withCredentials: true }); // added sending credentials stored in Cookie to cross-domain
export const LoginAPI = axios.create({ baseURL: PUBLIC_API_ENDPOINT, withCredentials: true }); // added sending credentials stored in Cookie to cross-domain
